import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../../styles/LayoutStyles";
import FlowFieldInput from "../../../input/flow/field/FlowFieldInput";
import InputWrapper from "../../../input/wrapper/InputWrapper";
import FlowPlayerControls from "../../controls/FlowPlayerControls";

function FieldsStepView({ controller, onFieldChange }) {
  const { translate, translateEntity } = useLanguageContext();

  /**
   * This method will return if the condition of the given step field is met
   * @param {object} stepField
   * @returns {boolean}
   */
  function isConditionMet(stepField) {
    if (!stepField.condition_key || !stepField.condition_effect) return false;

    const result = controller.stepResults?.[stepField.condition_key];
    return String(result ? 1 : 0) === String(stepField.condition_value);
  }

  /**
   * This method will return if the given step field is hidden
   * @param {object} stepField
   * @returns {boolean}
   */
  function isHidden(stepField) {
    if (stepField.condition_effect === "hidden") {
      return isConditionMet(stepField);
    }

    return stepField[`hidden_${controller.getFlowType()}`];
  }

  /**
   * This method will return if the given step field is required
   * @param {object} stepField
   * @returns {boolean}
   */
  function isRequired(stepField) {
    if (stepField.condition_effect === "required") {
      return isConditionMet(stepField);
    }

    return stepField[`required_${controller.getFlowType()}`];
  }

  return (
    <FlowPlayerControls controller={controller}>
      <StyledFlexColumn>
        {controller.step.fields.map((row, index) => {
          const fields = row.filter((sf) => !isHidden(sf));

          return (
            fields.length > 0 && (
              <StyledFlexRow key={index}>
                {fields.map((stepField) => (
                  <StyledFlexItem key={stepField.id}>
                    <InputWrapper
                      label={
                        stepField.field
                          ? translateEntity(stepField.field, "label")
                          : translate(
                              `eva.main.validation.attributes.${stepField.default_field}`,
                            )
                      }
                      required={isRequired(stepField)}
                      error={EVAApiHelper.getResponseError(
                        stepField.field
                          ? `field_${stepField.field.id}`
                          : stepField.default_field,
                        controller.errors,
                      )}
                    >
                      <FlowFieldInput
                        flowField={stepField}
                        value={
                          controller.visitorData[
                            stepField.field
                              ? `field_${stepField.field.id}`
                              : stepField.default_field
                          ]
                        }
                        onChange={onFieldChange}
                        disabled={
                          stepField[`readonly_${controller.getFlowType()}`]
                        }
                      />
                    </InputWrapper>
                  </StyledFlexItem>
                ))}
              </StyledFlexRow>
            )
          );
        })}
      </StyledFlexColumn>
    </FlowPlayerControls>
  );
}

export default FieldsStepView;
